<template>
  <Bubble
    id="my-bubble-chart-id"
    :options="chartOptions"
    :data="chartData"
  />
</template>

<script>
import { Bubble } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement, Filler } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BubbleChart',
  components: { Bubble },
  props: {
    dataset: {
      type: Array,
      default: () => { return [] }
    },
    yTicksCallback: {
      type: Function
    },
    tooltipLabelCallback: {
      type: Function
    }
  },
  data () {
    var rightNow = new Date()
    // var month = rightNow.getMonth() + 1
    var day = rightNow.getDate()
    return {
      width: null,
      height: null,
      chartObj: null,
      isWaitingToResize: false,
      chartData: {
        // labels: ['January', 'February'],
        datasets: [{
          // label: 'Nº of assessments',
          borderColor: this.updateBorderColorRead,
          data: [],
          backgroundColor: this.updateBorderColorRead// 'rgb(255, 99, 132)'
        }]
      },
      chartOptions: {
        responsive: true,
        // maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false
            },
            min: day - 31,
            // suggestedMax: day,
            max: day - 1,
            ticks: {
              callback: function (value, index, ticks) {
                return value < 0 ? 31 + value : value
              },
              padding: 1
            }
          },
          y: {
            grid: {
              display: false
            },
            ticks: {
              // Include a dollar sign in the ticks
              callback: this.yTicksCallback
            },
            /* ticks: {
              beginAtZero: true
            } */
            min: 0,
            suggestedMax: 60
          }
        },
        plugins: {
          legend: {
            display: false,
            position: 'bottom'
          },
          tooltip: {
            callbacks: {
              label: this.tooltipLabelCallback
            }
          }
        },
        /* tooltips: {
          // backgroundColor: '#f5f5f5',
          titleFontColor: '#333',
          bodyFontColor: '#666',
          bodySpacing: 4,
          xPadding: 12,
          mode: 'nearest',
          intersect: false,
          position: 'nearest'
        }, */
        interaction: {
          intersect: false
        },
        elements: {
          line: {
            tension: 0.4
          }
        },
        aspectRatio: 'auto'
        /* scales: {
          yAxes: [{
            barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(29,140,248,0.0)',
              zeroLineColor: 'transparent'
            },
            ticks: {
              suggestedMin: 60,
              suggestedMax: 125,
              padding: 20,
              fontColor: '#9a9a9a'
            }
          }],

          xAxes: [{
            barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(225,78,202,0.1)',
              zeroLineColor: 'transparent'
            },
            ticks: {
              padding: 20,
              fontColor: '#9a9a9a'
            }
          }]
        } */
      }
    }
  },
  mounted () {
    this.$watch('dataset', (newVal, oldVal) => {
      this.chartData.datasets[0].data = { x: 20, y: 40, r: 10 }// this.dataset[0]
      // this.chartData.datasets[1].data = { x: 10, y: 40, r: 50 }// this.dataset[0]
      if (this.chartObj) {
        this.chartObj.data.datasets = []
        // this.chartObj.data.datasets[0].data =
        // var datasets = [[{ x: 20, y: 40, r: 10 }]]
        // var datasets = [{ backgroundColor: 'rgba(240,140,0,0.1)', dataset: this.dataset }, { backgroundColor: 'rgba(140,40,0,0.5)', dataset: [{ x: 10, y: 40, r: 50 }] }]
        // var datasets = this.divideDatasetInScales(this.dataset)
        var datasets = [{
          // label: 'Nº of assessments',
          data: this.dataset,
          backgroundColor: 'rgba(18, 210, 114, 0.59)'
        }]
        // var datasets = [this.dataset]
        datasets.forEach((dataset, idx) => {
          this.chartObj.data.datasets.push(dataset)
        })
        this.chartObj.update()
        // window.onresize = this.askToReDrawChart
      }
    })
  },
  methods: {
    divideDatasetInScales (dataset) {
      var maxR = 0
      dataset.map(e => { if (e.r > maxR) maxR = e.r; return 0 })

      var veryLowData = []
      var lowData = []
      var averageData = []
      var highData = []
      var veryHighData = []
      dataset.map(e => {
        if (e.r < maxR / 5) {
          veryLowData.push(e)
        } else if (e.r < (maxR * 2) / 5) {
          lowData.push(e)
        } else if (e.r < (maxR * 3) / 5) {
          averageData.push(e)
        } else if (e.r < (maxR * 4) / 5) {
          highData.push(e)
        } else {
          veryHighData.push(e)
        }
        return 0
      })
      var datasets = []
      datasets.push({
        label: 'Very low',
        data: veryLowData,
        backgroundColor: 'rgba(105, 237, 171, 0.5)'
      })
      datasets.push({
        label: 'Low',
        data: averageData,
        backgroundColor: 'rgba(18, 210, 114, 0.59)'
      })
      datasets.push({
        label: 'Average',
        data: averageData,
        backgroundColor: 'rgba(243, 213, 92, 0.84)'
      })
      datasets.push({
        label: 'High',
        data: highData,
        backgroundColor: 'rgba(245, 97, 48, 0.59)'
      })
      datasets.push({
        label: 'Very high',
        data: veryHighData,
        backgroundColor: 'rgba(243, 49, 39, 0.84)'
      })
      return datasets
    },
    askToReDrawChart () {
      if (this.chartObj && !this.isWaitingToResize) {
        this.isWaitingToResize = true
        setTimeout(this.reDrawChart, 500)
        /* this.chartObj.resize()
        console.log('chartObj.resize()') */
      }
    },
    reDrawChart () {
      this.isWaitingToResize = false
      this.chartObj.resize()
      console.log('chartObj.resize()')
    },
    updateBorderColorRead (context) {
      if (!this.chartObj) {
        this.chartObj = context.chart
      }
      const chart = context.chart
      const { ctx, chartArea } = chart

      if (!chartArea) {
        // This case happens on initial chart load
        return
      }
      // return this.getGradient(ctx, chartArea, ['rgba(240,140,0,0.1)', 'rgba(240,140,0,0.5)', 'rgba(240,140,0,1)'], this.gradientRead)
      return 'rgba(18, 210, 114, 0.59)'
    },
    getGradient (ctx, chartArea, color, gradient) {
      const chartWidth = chartArea.right - chartArea.left
      const chartHeight = chartArea.bottom - chartArea.top
      if (!gradient || this.width !== chartWidth || this.height !== chartHeight) {
        // Create the gradient because this is either the first render
        // or the size of the chart has changed
        this.width = chartWidth
        this.height = chartHeight
        gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top)
        gradient.addColorStop(0, color[0])
        gradient.addColorStop(0.5, color[1])
        gradient.addColorStop(1, color[2])
      }

      return gradient
    }
  }
}
</script>
